import ProductListSectionTwo from './productListSectionTwo'

export default ProductListSectionTwo

export { ProductListSectionTwo }
